// extracted by mini-css-extract-plugin
export var bodyRow = "_cq-d";
export var cardColumns = "_cq-e";
export var ellipsesOverflow = "_cq-2";
export var flatBottomCorners = "_cq-3";
export var flatTopCorners = "_cq-4";
export var headerActionsDropdown = "_cq-f";
export var headerBottomRow = "_cq-c";
export var headerTopRow = "_cq-b";
export var orderDetailsWrapper = "_cq-0";
export var orderInfoContainer = "_cq-1";
export var productDetails = "_cq-9";
export var productImage = "_cq-5";
export var responsiveTable = "_cq-8";
export var shipmentContainer = "_cq-a";
export var tableBottomLeft = "_cq-6";
export var tableBottomRight = "_cq-7";
export var trackingLink = "_cq-g";